import React from 'react'
import { connect } from 'react-redux'
import { Route, Redirect } from 'react-router-dom'

import { isAuthenticatedSelector, isAuthorizedSelector } from 'selectors'

import NotFound from 'pages/NotFound'

const PrivateRoute = ({
  isAuthenticated,
  isAuthorized,
  component: Component,
  ...rest
}) => (
  <Route
    {...rest}
    render={props => {
      if (!isAuthenticated) {
        return (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: props.location },
            }}
          />
        )
      } else if (!isAuthorized) {
        return <NotFound />
      } else {
        return <Component {...props} />
      }
    }}
  />
)

const mapStateToProps = (state, { userTypes }) => ({
  isAuthenticated: isAuthenticatedSelector(state),
  isAuthorized: isAuthorizedSelector(state, userTypes),
})

export default connect(mapStateToProps)(PrivateRoute)



// WEBPACK FOOTER //
// ./src/Router/PrivateRoute.js